export default "__VITE_ASSET__8b8dbe7c__"